import moment from "moment"
import React, { useCallback, useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { archiveProgram } from "../../requesters/Backend/ProgramRequester"
import { getUnitDetail } from "../../requesters/Backend/UnitRequester"
import AddProgramPage from "./AddProgramPage"
import UpdateUnitPage from "./UpdateUnitPage"

function UnitDetailPage({ baseUrl, currentUser }) {
  const { unitId } = useParams()
  const [unitDetail, setUnitDetail] = useState({})
  const [editable, setEditable] = useState(false)
  const [editableProgram, setEditableProgram] = useState(false)

  const fetchUnitDetail = useCallback(() => {
    getUnitDetail(baseUrl, unitId, currentUser)
      .then(res => {
        setUnitDetail(res.response)
        return null
      })
      .catch(err => {
        toast.error(`${err}, Unit not found`)
      })
  }, [baseUrl, currentUser, unitId])

  useEffect(() => {
    fetchUnitDetail()
  }, [fetchUnitDetail])

  const onChangeEditable = () => {
    setEditable(!editable)
  }

  const onChangeEditablePrograms = () => {
    setEditableProgram(!editableProgram)
  }

  const onChangeArchived = e => {
    const newStatus = e.target.checked ? "active" : "inactive"
    archiveProgram(baseUrl, e.target.name, newStatus, currentUser).then(res => {
      if (res.status === 201) {
        toast.success(`Program Status successfully updated to: ${newStatus}`)
      } else {
        toast.error(`Program Status not updated`)
      }
    }).catch(err => {
      toast.error(`${err}`)
    })
  }

  if (editable) {
    return (
      <UpdateUnitPage
        baseUrl={baseUrl}
        currentUser={currentUser}
        fetchUnitDetail={fetchUnitDetail}
        onChangeEditable={onChangeEditable}
        unitDetail={unitDetail} />
    )
  }

  if (editableProgram) {
    return (
      <AddProgramPage
        baseUrl={baseUrl}
        currentUser={currentUser}
        fetchUnitDetail={fetchUnitDetail}
        onChangeEditable={onChangeEditablePrograms}
        unitDetail={unitDetail} />
    )
  }

  const { organisation = {}, programs = [] } = unitDetail

  return (
    <div className="content">
      <div className="container-fluid">
        <div className="form-container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={`/backend/organisations/${organisation.id}`}>{organisation.name}</Link>
              </li>
              <li aria-current="page" className="breadcrumb-item active">{unitDetail.name}</li>
            </ol>
          </nav>
          <h1>{unitDetail.name}</h1>
          <div className="card-section">
            <div className="card">
              <div className="card-header"><h5>Programs</h5></div>
              <div className="card-body">
                <table className="table">
                  <tbody>
                    {programs.map((program, index) => (
                      <tr key={program.id}>
                        <td>{moment(program.created_at).format("DD/MM/YYYY hh:mm")}</td>
                        <td aria-label="spacer">&nbsp;</td>
                        <td><Link to={`/backend/programs/${program.id}`}>{program.name}</Link></td>
                        <td className="text-right">{program.unique_id}</td>
                        <td className="text-right">
                          <div className="custom-control custom-switch">
                            <input
                              onChange={onChangeArchived}
                              defaultChecked={program.status === "active"}
                              className="custom-control-input"
                              id={`customSwitch${index}`}
                              name={program.id}
                              type="checkbox" />
                            <label className="custom-control-label" htmlFor={`customSwitch${index}`}>
                              <span className="sr-only">
                                Toggle archived status for
                                {program.name}
                              </span>
                            </label>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <button type="button" className="btn btn-outline-main btn-sm" onClick={onChangeEditablePrograms}>+ Add Program</button>
              </div>
            </div>
            <div className="card">
              <div className="card-header"><h5>Contact</h5></div>
              <div className="card-body">
                <ul className="list-unstyled">
                  <li>{unitDetail.contact_name}</li>
                  <li>{unitDetail.contact_email}</li>
                  <li>{unitDetail.contact_number}</li>
                </ul>
                <button
                  className="btn btn-outline-main btn-sm"
                  onClick={onChangeEditable}
                  type="button">
                  Edit
                </button>
                {/* TO DO: make link more elegant */}
                {/* <Link
                  className="btn btn-outline-main btn-sm"
                  to={`${location.pathname}/edit`}>
                  Edit
                </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UnitDetailPage
